import type { Epic } from 'redux-observable';
import initiateStore, { type Store } from '@jira/platform__tangerine/src/initiateStore.tsx';
import rootReducer from './reducer/rootReducer.tsx';
import type { Action, State } from './types.tsx';

export const createStore = (rootEpic?: Epic<Action, State>): Store<State> =>
	initiateStore<State, Action, undefined>({
		appName: 'flags',
		rootReducer,
		rootEpic,
	});
